import Vue from 'vue';
import router from './router';
import App from './App.vue';
import store from "./store";

// button
import ZeroButton from '@/components/ZeroButton';

Vue.component('z-button', ZeroButton);
//Background
import Background from '@/layout/Background';

Vue.component('Background', Background);
//FooterNav
import FooterNav from '@/components/FooterNav';

Vue.component('FooterNav', FooterNav);

import '@/styles/reset.scss';


import PortalComponent from 'portal-component';
import 'portal-component/lib/theme-chalk/index.css';
Vue.use(PortalComponent);

import sw from 'sw-ui';
import 'sw-ui/lib/theme-chalk/index.css';
Vue.use(sw);

import SwIcon from "sw-icon";
Vue.use(SwIcon);

import colorPicker from 'vcolorpicker'
Vue.use(colorPicker)
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

Vue.use(VueQuillEditor, /* { default global options } */)

Vue.config.productionTip = false;
import enumeratedData from '@/utils/enumeratedData';
Vue.prototype.$enumeratedData = enumeratedData;
import config from '@/config';
import request from "@/utils/request";
Vue.prototype.$config = config;
Vue.prototype.$request = request;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
